import { type AxiosRequestConfig } from 'axios';

import { fetchApi } from '../../services';
import { getSaviApiUrlLists } from '../../services/ispmUtil';
import { type GetIspmSuggestionsResponse } from '../types';

// Base URL for the API (replace with your actual API endpoint)
const { CHAT_SUGGESTIONS_URL } = getSaviApiUrlLists(false);

function isSuggestionsResponse(
  data: unknown
): data is GetIspmSuggestionsResponse {
  return (
    typeof data === 'object' &&
    data !== null &&
    'suggestions' in data &&
    Array.isArray((data as GetIspmSuggestionsResponse).suggestions) &&
    (data as GetIspmSuggestionsResponse).suggestions.every(
      (item) =>
        typeof item === 'object' &&
        typeof item.text === 'string' &&
        typeof item.id === 'string'
    )
  );
}

// Function to fetch ISPM suggestions
const getSuggestions = async (
  url?: string
): Promise<GetIspmSuggestionsResponse> => {
  const suggestionUrl = url ?? CHAT_SUGGESTIONS_URL;
  const config: AxiosRequestConfig = {
    timeout: 30000, // Set timeout to 30 seconds
  };

  const response = await fetchApi(suggestionUrl, config, isSuggestionsResponse);

  return response;
};

export default getSuggestions;
